import React, { useState } from 'react';


import { Table, Empty, Button, Input, Select, Form, Tooltip, Tag } from 'antd';
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';
import './styles.css';
import { VENTA_DECIMAL } from '../../../../common/types/parametroType';
import auth from '../../../../common/utility/auth';

const { Option } = Select;

export default function DetalleProductoServicioModal(props) {

    const [visible, setVisible] = useState(false);

    const pesoVenta = auth.user().parametros.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 5;
    const cantidadVenta = auth.user().parametros.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 3;

    return (
        <div>
            <Table
                className={'table-reporte-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 10,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Código',
                        dataIndex: 'codigo',
                        key: 'codigo',
                        align: 'center',
                        width: 80,
                        ellipsis: true,
                    },
                    {
                        title: 'Nombre',
                        dataIndex: 'nombre',
                        key: 'nombre',
                        width: 300,
                        ellipsis: true,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {
                                        props.onGetFieldDecorator(`arrNombre[${row.nombre}]`, {
                                            initialValue: value
                                        })(
                                            <Input
                                                placeholder="Nombre"
                                                autoComplete="off"
                                                className="text-left"
                                                readOnly={true}
                                                onClick={(e) => props.onChangeNameProduct(row)}
                                            />
                                        )
                                    }

                                </Form.Item>
                            )
                        }
                    },
                    {
                        title: 'UM',
                        dataIndex: 'idUnidadMedida',
                        key: 'idUnidadMedida',
                        width: 120,
                        ellipsis: true,
                        render: (value, row, index) => {
                            return (
                                props.motivo == 6 || props.motivo == 7 ?
                                    <Form.Item>
                                        {props.onGetFieldDecorator(`arridUnidadMedida[${row.identifier}]`, {
                                            initialValue: value ? { key: value } : undefined,
                                            validateTrigger: ['onBlur'],
                                            rules: [{
                                                required: true,
                                                message: "Seleccione medida"
                                            }]
                                        })(
                                            <Select showSearch labelInValue
                                                placeholder={"Seleccione Unidad Medida"}
                                                optionFilterProp="children"
                                                onChange={(option) => props.onCalculateDetail(index, row.identifier, row, "arridUnidadMedida", option.key, 3)}
                                            >
                                                {props.unidadesMedida.map(item => (
                                                    <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                    :
                                    <span>{row.nombreUnidadMedida} </span>
                            );
                        }
                    },

                    {
                        title: 'Peso Unitario',
                        dataIndex: 'pesoUnitario',
                        key: 'pesoUnitario',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPesoUnitario[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(pesoVenta),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(pesoVenta == 2 ? FORMAT_2DECIMALS : FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        },
                                        {
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Valor mayor a 0.00"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Peso Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(index, row.identifier, row, "arrPesoUnitario", e.target.value, 5)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrCantidad[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(cantidadVenta),
                                        rules: [
                                            {
                                                required: true,
                                                pattern: new RegExp(cantidadVenta == 2 ? FORMAT_2DECIMALS : FORMAT_3DECIMALS),
                                                message: "Formato (0.000)"
                                            },
                                            {
                                                required: true,
                                                pattern: new RegExp(GREATER_THAN_ZERO),
                                                message: "Valor mayor a 0.00"
                                            }
                                        ]
                                    })(
                                        <Input
                                            placeholder="Cantidad"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(index, row.identifier, row, "arrCantidad", e.target.value, 3)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Peso Total',
                        dataIndex: 'totalPeso',
                        key: 'totalPeso',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrTotalPeso[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(cantidadVenta),
                                        rules: [
                                            {
                                                required: true,
                                                pattern: new RegExp(cantidadVenta == 2 ? FORMAT_2DECIMALS : FORMAT_3DECIMALS),
                                                message: "Formato (0.000)"
                                            }
                                        ]
                                    })(
                                        <Input
                                            placeholder="Peso Total"
                                            autoComplete="off"
                                            disabled={!props.flagEditCode}

                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(index, row.identifier, row, "arrTotalPeso", e.target.value, 3)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    }
                ]}
            />

        </div>
    );
}